(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
    // Find the buy buttons block by looking for the product form buttons container
    const productFormButtons = document.querySelector('[ref="productFormButtons"]');
    if (!productFormButtons) return;

    const buyButtonsBlock = productFormButtons.closest('.buy-buttons-block');
    if (!buyButtonsBlock) return;

    const section = buyButtonsBlock.closest('.shopify-section');
    if (!section) return;

    const handleVariantUpdate = (event) => {
      const variant = event.detail.resource;
      const addToCartWrapper = productFormButtons.querySelector('[ref="addToCartWrapper"]');
      const klaviyoButton = productFormButtons.querySelector('[ref="klaviyoNotifyButton"]');
      const variantIdInput = buyButtonsBlock.querySelector('[ref="variantId"]');

      if (!variant || !variant.available) {
        // Hide add to cart button and show Klaviyo button
        if (addToCartWrapper) {
          addToCartWrapper.style.display = 'none';
        }
        if (klaviyoButton) {
          // Update variant ID on the container and button
          klaviyoButton.setAttribute('data-variant-id', variant.id);
          
          const button = klaviyoButton.querySelector('button');
          if (button) {
            button.setAttribute('data-variant-id', variant.id);
          }
          
          // Show the Klaviyo button
          klaviyoButton.style.display = 'block';
          
          // Ensure Klaviyo detects the variant change
          // Klaviyo reads the variant ID from the form's hidden input field (ref="variantId")
          // The variant ID input is updated by product-form.js before this event fires
          // Trigger a custom event that Klaviyo might listen to, or force a re-scan
          setTimeout(() => {
            // Dispatch a custom event for Klaviyo to potentially listen to
            const klaviyoEvent = new CustomEvent('klaviyo:variant:changed', {
              detail: { variantId: variant.id },
              bubbles: true
            });
            klaviyoButton.dispatchEvent(klaviyoEvent);
            
            // If Klaviyo has a method to update, call it
            if (window.klaviyo && typeof window.klaviyo.load === 'function') {
              try {
                window.klaviyo.load('backinstock', { variant: variant.id });
              } catch (e) {
                // Klaviyo will automatically detect the variant from the form input
              }
            }
          }, 50);
        }
      } else {
        // Show add to cart button and hide Klaviyo button
        if (addToCartWrapper) {
          addToCartWrapper.style.display = '';
        }
        if (klaviyoButton) {
          klaviyoButton.style.display = 'none';
        }
      }
    };

    section.addEventListener('variant:update', handleVariantUpdate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-carousel-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const wrappers = document.querySelectorAll('.pdp-carousel-upsell__scroller-wrap');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const scroller = wrapper.querySelector('.pdp-carousel-upsell__scroller[data-desktop-draggable]');
      if (!scroller) return;
      if (scroller.dataset.dragInit === 'true') return;
      scroller.dataset.dragInit = 'true';
      const leftArrow = wrapper.querySelector('[data-scroll-left]');
      const rightArrow = wrapper.querySelector('[data-scroll-right]');

      let isPointerDown = false;
      let isDragging = false;
      let suppressClick = false;
      let startX = 0;
      let startScrollLeft = 0;
      let currentDelta = 0;
      let rafId = 0;

      const applyScroll = () => {
        scroller.scrollLeft = startScrollLeft - currentDelta;
        rafId = 0;
      };
      const updateArrows = () => {
        if (!leftArrow || !rightArrow || !desktopMedia.matches) return;
        const maxLeft = scroller.scrollWidth - scroller.clientWidth;
        leftArrow.classList.toggle('is-hidden', scroller.scrollLeft <= 2);
        rightArrow.classList.toggle('is-hidden', scroller.scrollLeft >= maxLeft - 2);
      };
      const scrollByAmount = (direction) => {
        const amount = Math.max(scroller.clientWidth * 0.8, 220);
        scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      const onPointerDown = (event) => {
        if (!desktopMedia.matches || event.button !== 0) return;

        isPointerDown = true;
        isDragging = false;
        currentDelta = 0;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.setPointerCapture(event.pointerId);
      };

      const onPointerMove = (event) => {
        if (!desktopMedia.matches || !isPointerDown) return;

        currentDelta = event.clientX - startX;
        if (!isDragging && Math.abs(currentDelta) > 6) {
          isDragging = true;
          scroller.classList.add('is-dragging');
        }

        if (!isDragging) return;

        if (!rafId) {
          rafId = requestAnimationFrame(applyScroll);
        }
        event.preventDefault();
      };

      const endDrag = (event) => {
        if (!isPointerDown) return;
        isPointerDown = false;

        if (scroller.hasPointerCapture(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }

        if (rafId) {
          cancelAnimationFrame(rafId);
          applyScroll();
        }

        if (isDragging) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }

        isDragging = false;

        requestAnimationFrame(() => {
          scroller.classList.remove('is-dragging');
        });
      };

      scroller.addEventListener('pointerdown', onPointerDown);
      scroller.addEventListener('pointermove', onPointerMove);
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      desktopMedia.addEventListener('change', updateArrows);
      leftArrow?.addEventListener('click', () => scrollByAmount(-1));
      rightArrow?.addEventListener('click', () => scrollByAmount(1));

      // Prevent accidental card click right after dragging.
      scroller.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
      updateArrows();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
